import {
  LooseBlade,
  Page,
  PageSchema,
} from "@riot-private/blades-ui/blades-api-client";
import {
  AllBladeContracts,
  AllBladeContractsSchema,
} from "@riot-private/blades-ui";
import { fromZodError } from "zod-validation-error";
import { ZodError } from "zod";

export function parsePageResponse(response: unknown): Page {
  try {
    return PageSchema.parse(response);
  } catch (error) {
    console.error(response);
    throw new Error(
      `Invalid response received from PCS API for the page details: ${error}`,
    );
  }
}

export class BladeValidationError extends Error {
  constructor(
    message: string,
    public cause: ZodError,
    public input: unknown,
  ) {
    super(message);
  }
}

export function formatBladeValidationError(error: BladeValidationError) {
  return fromZodError(error.cause, {
    issueSeparator: "\n * ",
    prefix: error.message,
    prefixSeparator: ":\n * ",
    unionSeparator: "\n    or ",
  }).toString();
}

export function parseBladeData(
  blade: LooseBlade,
  index: number,
): AllBladeContracts {
  try {
    const result = AllBladeContractsSchema.safeParse(blade);

    if (!result.success) {
      throw new BladeValidationError(
        `Invalid Blade data from blade [${index + 1}:${blade.type}]`,
        result.error,
        blade,
      );
    }

    return result.data;
  } catch (cause) {
    if (cause instanceof BladeValidationError) {
      throw cause;
    }

    throw new Error(
      `Invalid Blade shape from blade [${index + 1}:${
        blade.type
      }]: ${cause} ${JSON.stringify(blade)}`,
      { cause: cause },
    );
  }
}
